import { render } from "./PrivateDirector.vue?vue&type=template&id=e986fea6"
import script from "./PrivateDirector.vue?vue&type=script&lang=js"
export * from "./PrivateDirector.vue?vue&type=script&lang=js"

import "./PrivateDirector.vue?vue&type=style&index=0&id=e986fea6&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__